var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"elevation-0"},[_c('cliente-datos',{attrs:{"cliente":_vm.cliente}}),_c('cliente-direcciones'),_c('cliente-BI')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }